module.exports = __webpack_public_path__ + "img/voteCount.60cb3714.png";